import type { ErrorType } from '~/data/ErrorRecord';
import DataExportStatusConstants from '~/constants/data-export-status-constants';
import { createExportHistoryEntry } from './ExportHistoryEntry';
import {
  createYearMonth,
  defaultYearMonth,
  YearMonthFields,
} from './YearMonth';
import type { ExportHistoryEntry } from './ExportHistoryEntry';

export const defaultState: Fields = {
  isLoading: false,
  activeExport: null,
  exportHistory: [],
  defaultFromDate: defaultYearMonth,
  defaultToDate: defaultYearMonth,
  minDate: defaultYearMonth,
  maxDate: defaultYearMonth,
  isPollingActive: false,
  pollingError: undefined,
};

export interface Fields {
  isLoading: boolean;
  activeExport: ExportHistoryEntry | null;
  exportHistory: ExportHistoryEntry[];
  defaultFromDate: YearMonthFields;
  defaultToDate: YearMonthFields;
  minDate: YearMonthFields;
  maxDate: YearMonthFields;
  isPollingActive: boolean;
  pollingError?: ErrorType;
}

export const setFromResponse = (state: Fields, data) => {
  if (!data) {
    return state;
  }

  const {
    activeExport,
    exportHistory,
    fromDate,
    toDate,
    minDate,
    maxDate,
  } = data;

  state.activeExport = activeExport
    ? createExportHistoryEntry(activeExport)
    : null;
  state.exportHistory = exportHistory.map(createExportHistoryEntry);
  state.defaultFromDate = createYearMonth(fromDate);
  state.defaultToDate = createYearMonth(toDate);
  state.minDate = createYearMonth(minDate);
  state.maxDate = createYearMonth(maxDate);
  return state;
};

export const updateIsPollingActive = (state: Fields) => {
  state.isPollingActive =
    state.activeExport !== null &&
    state.activeExport.status !== DataExportStatusConstants.CREATED &&
    state.activeExport.status !== DataExportStatusConstants.ERROR;

  return state;
};

export const prependExportToHistory = (
  exportHistory: ExportHistoryEntry[],
  historyEntry: Partial<ExportHistoryEntry>,
  maxSize = 10
) => {
  exportHistory.unshift(createExportHistoryEntry(historyEntry));
  return exportHistory.slice(0, maxSize);
};

export const setIsLoadingDownloadLink = (
  state: Fields,
  id: string,
  isLoading: boolean
) => {
  const index = state.exportHistory.findIndex((entry) => entry.id === id);
  if (index === -1) {
    return state;
  }

  state.exportHistory[index].isLoadingDownloadUrl = isLoading;
  return state;
};

// export default class DataExportCardRecord extends Record<Fields>(keys) {
//   // setFromResponse(data) {
//   //   if (!data) {
//   //     return this;
//   //   }
//   //
//   //   const {
//   //     activeExport,
//   //     exportHistory,
//   //     fromDate,
//   //     toDate,
//   //     minDate,
//   //     maxDate,
//   //   } = data;
//   //
//   //   return this.setActiveExport(activeExport)
//   //     .setExportHistory(exportHistory)
//   //     .merge({
//   //       defaultFromDate: new YearMonthRecord(fromDate),
//   //       defaultToDate: new YearMonthRecord(toDate),
//   //       minDate: new YearMonthRecord(minDate),
//   //       maxDate: new YearMonthRecord(maxDate),
//   //     });
//   // }
//   // updateIsPollingActive() {
//   //   const isPollingActive =
//   //     this.activeExport !== null &&
//   //     this.activeExport.status !== DataExportStatusConstants.CREATED &&
//   //     this.activeExport.status !== DataExportStatusConstants.ERROR;
//   //
//   //   return this.merge({ isPollingActive });
//   // }
//   // setActiveExport(activeExport) {
//   //   return this.merge({
//   //     activeExport: activeExport
//   //       ? new ExportHistoryEntryRecord(activeExport)
//   //       : null,
//   //   });
//   // }
//   // setExportHistory(exportHistory) {
//   //   return this.merge({
//   //     exportHistory: List(
//   //       exportHistory.map((entry) => new ExportHistoryEntryRecord(entry))
//   //     ),
//   //   });
//   // }
//   // prependExportToHistory(historyEntry, maxSize = 10) {
//   //   return this.update('exportHistory', (exportHistory) => {
//   //     return exportHistory
//   //       .unshift(new ExportHistoryEntryRecord(historyEntry))
//   //       .slice(0, maxSize);
//   //   });
//   // }
//   //
//   // setIsLoadingDownloadLink(id, isLoading) {
//   //   const index = this.exportHistory.findIndex((entry) => entry.id === id);
//   //   if (index === -1) {
//   //     return this;
//   //   }
//   //
//   //   return this.update('exportHistory', (exportHistory) => {
//   //     return exportHistory.update(index, (entry) =>
//   //       entry.set('isLoadingDownloadUrl', isLoading)
//   //     );
//   //   });
//   // }
// }
